import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./Toggle.module.scss";
export const Toggle = ({ onChange, value, disabled, className, dataTestId, id }) => {
    const handleChange = (event) => {
        const { checked } = event.target;
        onChange(checked);
    };
    return (_jsxs("label", { htmlFor: id, "data-testid": dataTestId, className: classNames(styles.wrapper, className, {
            [styles.wrapperActive]: value,
            [styles.wrapperDisabled]: disabled,
        }), children: [_jsx("input", { "aria-labelledby": `label-${id}`, type: "checkbox", id: id, checked: value, disabled: disabled, onChange: handleChange, className: styles.checkboxInput }), _jsx("span", { className: styles.circle })] }));
};
//# sourceMappingURL=Toggle.js.map